module.exports = __webpack_public_path__ + "img/img-aec1eb85.9887a6df.png";